import { useTranslation } from 'react-i18next';

import { Loader, Modal, ModalProps } from '@mantine/core';

import styles from './FileUploadingModal.module.css';

const FileUploadingModal = (props: ModalProps) => {
   const { t } = useTranslation();

   return (
      <Modal
         {...props}
         title={t('sendPalletsModal.fileUploadingModal.title')}
         size={600}
         withCloseButton={false}
         centered
      >
         <div className={styles.container}>
            <span className={styles.loader}>
               <Loader color={'var(--light-green)'} size={38} />
            </span>
            <p>{t('sendPalletsModal.fileUploadingModal.description')}</p>
         </div>
      </Modal>
   );
};

export default FileUploadingModal;
